import { ComponentTypes } from '@wix/wix-data-client-common-standalone'
import { FieldType } from '@wix/wix-data-schema-types'

const {
  text: TEXT,
  number: NUMBER,
  boolean: BOOLEAN,
  stringArray: STRING_ARRAY,
} = FieldType

export const COMPONENT_TYPES_FILTERABLE_BY_USER_INPUT = {
  [ComponentTypes.Dropdown]: {
    supportedFieldTypes: [TEXT, NUMBER],
    filterPanelLabel:
      'Dataset_Settings_Add_Filter_Panel_User_Input_Dropdown_Option_Label',
    filterPanelError:
      'Dataset_Settings_Add_Filter_Panel_User_Input_Dropdown_Error_Field_Type',
    datasetSettingsPanelLabel:
      'Dataset_Settings_Panel_Filter_By_User_Input_Dropdown_Element_Name',
  },
  [ComponentTypes.Checkbox]: {
    supportedFieldTypes: [BOOLEAN],
    filterPanelLabel:
      'Dataset_Settings_Add_Filter_Panel_User_Input_Checkbox_Option_Label',
    filterPanelError:
      'Dataset_Settings_Add_Filter_Panel_User_Input_Checkbox_Error_Field_Type',
    datasetSettingsPanelLabel:
      'Dataset_Settings_Panel_Filter_By_User_Input_Checkbox_Element_Name',
  },
  [ComponentTypes.CheckboxGroup]: {
    supportedFieldTypes: [STRING_ARRAY],
    filterPanelLabel:
      'Dataset_Settings_Add_Filter_Panel_User_Input_MultiSelect_Option_Label',
    filterPanelError:
      'Dataset_Settings_Add_Filter_Panel_User_Input_MultiSelect_Error_Field_Type',
    datasetSettingsPanelLabel:
      'Dataset_Settings_Panel_Filter_By_User_Input_MultiSelect_Element_Name',
    spec: 'specs.wixCode.FilterByCheckboxGroupUserInput',
  },
}
